import { render, staticRenderFns } from "./remote_treatment_doc.vue?vue&type=template&id=7165c1e5&scoped=true"
import script from "./remote_treatment_doc.vue?vue&type=script&lang=js"
export * from "./remote_treatment_doc.vue?vue&type=script&lang=js"
import style0 from "./remote_treatment_doc.vue?vue&type=style&index=0&id=7165c1e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7165c1e5",
  null
  
)

export default component.exports